import type { Colors } from '../theme';
import { scrollToId } from '../scroll';

interface NavItem {
  id: string;
  label: string;
}

interface Props {
  items: NavItem[];
  activeId: string;
  colors: Colors;
}

export default function ContentsRail({ items, activeId, colors }: Props) {
  return (
    <nav style={{
      position: "fixed",
      right: 32,
      top: "50%",
      transform: "translateY(-50%)",
      display: "flex",
      flexDirection: "column",
      gap: 20,
      zIndex: 5,
    }}>
      {items.map(({ id, label }) => {
        const isActive = id === activeId;
        return (
          <button
            key={id}
            onClick={() => scrollToId(id)}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              fontFamily: "'0xProto', 'JetBrains Mono', monospace",
              fontSize: 12,
              color: isActive ? colors.fg : colors.muted,
              fontWeight: isActive ? 600 : 400,
              padding: 0,
              textAlign: "right",
              transition: "color .2s ease",
              display: "flex",
              alignItems: "center",
              gap: 8,
              justifyContent: "flex-end",
            }}
          >
            {label}
            <span style={{
              display: "block",
              width: isActive ? 16 : 6,
              height: 1,
              background: isActive ? colors.fg : colors.muted,
              transition: "width .2s ease, background .2s ease",
              flexShrink: 0,
            }} />
          </button>
        );
      })}
    </nav>
  );
}
